<template>
  <el-dialog
    title="新增制度建设资料"
    :visible.sync="showDialog"
    width="500px"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="dialog-box">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="制度资料名称:" prop="designation">
          <el-input
            v-model="ruleForm.designation"
            size="small"
            clearable
            :maxlength="20"
            style="width:80%"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="制度资料地址:" prop="docAddress">
          <input
            type="file"
            id="xlsFile"
            accept=".xls,.xlsx,.doc,.docx"
            @change="importData($event)"
          />
          <el-button size="small" @click="selectFileImport"
            >上传制度资料</el-button
          >
          <el-input
            v-model="ruleForm.docAddress"
            size="small"
            type="textarea"
            clearable
            disabled
            style="width:80%"
          >
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="save-or-cencel-box">
      <el-button size="small" @click="handleClose">取消</el-button>
      <el-button type="primary" size="small" @click="saveClick('ruleForm')"
        >提交</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
export default {
  name: "RiskInstitutionalBuildingAdd",
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    resize: {
      type: Number,
      default: {
        return: 0
      }
    }
  },
  data() {
    //这里存放数据
    return {
      showDialog: false,
      rules: {
        designation: [{ required: true, message: " ", trigger: "blur" }],
        docAddress: [{ required: true, message: " ", trigger: "blur" }]
      },
      ruleForm: {
        schoolId: this.$store.state.schoolId,
        designation: "",
        docAddress: ""
      }
    };
  },
  //监控data中的数据变化
  watch: {
    resize: function(newVal) {
      if (newVal) {
        this.showDialog = true;
        console.log(newVal);
      }
    }
  },
  //方法集合
  methods: {
    handleClose(isRefresh) {
      this.clearData();
      this.showDialog = false;
    },
    clearData() {
      this.ruleForm = {
        schoolId: this.$store.state.schoolId,
        designation: "",
        docAddress: ""
      };
    },
    selectFileImport() {
      document.getElementById("xlsFile").click();
    },
    saveClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addInstitutionalBuilding();
        } else {
          return false;
        }
      });
    },
    async addInstitutionalBuilding() {
      let req = this.ruleForm;
      let res = await this.$Http.addInstitutionalBuilding(req, true);
      if (res.code == 200) {
        this.handleClose(true);
        this.$emit("getList");
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 导入数据
    async importData() {
      var fileUpload = event.target.files[0];
      if (!fileUpload) {
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "数据导入中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      var requestData = {
        file: fileUpload
      };
      var newData = {
        schoolId: this.$store.state.schoolId,
        file: fileUpload
      };
      document.getElementById("xlsFile").value = null;
      let res = await this.$Http.oneFileUpload(newData, true);

      // console.log(res)

      loading.close();
      if (res&&res.code == 200) {
        this.ruleForm.docAddress = Object.values(res.data)[0];
      } else {
        this.$message({
          type: "error",
          message:res&&res.messsage
        });
      }
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {},
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="scss">
.dialog-box {
  width: 100%;
  overflow-y: scroll;
  #xlsFile{
    display: none;
  }
}
.save-or-cencel-box {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
